




import Enumerable from "linq";
import { Component, Mixins, } from "vue-property-decorator";
import { ModelEditableMixin } from "../system/mixins";

@Component
export default class TransparentColorPicker extends Mixins(ModelEditableMixin) {
  get _colors(): { key: RegExp, convert: (s: string) => string }[] {
    return [
      { key: new RegExp("^#[0-9A-Fa-f]{4}$"), convert: (s: string) => this.createFromColorCode(this.pick1Digits(s, 1), this.pick1Digits(s, 2), this.pick1Digits(s, 3), this.pick1Digits(s, 4))},
      { key: new RegExp("^#[0-9A-Fa-f]{8}$"), convert: (s: string) => this.createFromColorCode(this.pick2Digits(s, 1), this.pick2Digits(s, 3), this.pick2Digits(s, 5), this.pick2Digits(s, 7))},
    ];
  }

  get color(): string {
    return this.editingSource !== "transparent"
      ? this.toRgba(this.editingSource)
      : "rgba(0, 0, 0, 0)";
  }

  set color(value: string) {
    this.editingSource = value;
  }

  private toRgba(color: string): string {
    const converter = Enumerable.from(this._colors).where(c => c.key.test(color)).firstOrDefault();
    return converter
      ? converter.convert(color)
      : color;
  }

  private createFromColorCode(red: number, green: number, blue: number, alpha: number): string {
    return "rgba(" + red + "," + green + "," + blue + "," + (alpha / 255) + ")";
  }

  private repeatText(source: string, count: number): string {
    return Array(count + 1).join(source);
  }

  private pick1Digits(source: string, index: number): number {
    return parseInt(this.repeatText(source.substring(index, (index + 1)), 2), 16);
  }

  private pick2Digits(source: string, index: number): number {
    return parseInt(source.substring(index, (index + 2)), 16);
  }
}
